var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 41,
    viewBox: "0 0 46 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M37.5 35H0V0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3-3h50v50H-3z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeDasharray: "2,2,2,2",
    transform: "translate(.75 5.75)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#80959D",
    strokeWidth: 2,
    d: "M37.5 35H0V0",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5 7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h33.75v29.787H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M.625.625h32.5v28.537H.625z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M.605 19.03l7.706-9.142a1.25 1.25 0 0 1 1.75-.16l23.263 19.114"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M17.666 16.548l7.654-4.52a1.25 1.25 0 0 1 1.426.108l6.514 5.32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.875,
    cy: 8.125,
    r: 1.875,
    fill: "rgba(21, 87, 191, 0.7)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(28.25 .75)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.125,
    cy: 8.125,
    r: 8.125,
    fill: "rgba(21, 87, 191, 0.7)",
    stroke: "#FFF",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.229 9.04H4.062V7.25H7.23V4.062h1.792V7.25h3.166v1.79H9.021v3.148H7.229z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/imageUpload.7d71ac3dabaeac56221f741dcdadb92a.svg";
export { ForwardRef as ReactComponent };